import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import stateBg from '../../../../images/Group 1.png';
import TestimonialSliderLg from '../TestimonialSliderLg/TestimonialSliderLg';
import TestimonialSliderSm from '../TestimonialSliderSm/TestimonialSliderSm';

const stateTextBg = {
    backgroundImage: `url(${stateBg})`,
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    paddingLeft: '2%'
}

const Testimonials = () => {
    return (
        <div>
            <Container sx={{ mt: 8 }}>
                <Box style={stateTextBg} sx={{ textAlign: 'left' }}>
                    <Typography variant="h6" id="stats-start" sx={{ color: '#0015D1', textDecoration: 'underline', fontWeight: 600, fontSize: '35px', pt: '2%' }}>
                        Testimonials
                    </Typography>
                    <Typography variant="h3" id="stats-title" sx={{ pt: 1, pb: 3, color: '#000D83', fontWeight: 600 }}>
                        What Our Clients Say about us
                    </Typography>
                </Box>
            </Container>
            <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>
                <TestimonialSliderLg />
            </Box>
            <Box sx={{ display: { xs: 'inline', sm: 'none' } }}>
                <TestimonialSliderSm />
            </Box>
        </div>
    );
};

export default Testimonials;